import { render, staticRenderFns } from "./order-packed.vue?vue&type=template&id=7bb87a1f"
import script from "./order-packed.vue?vue&type=script&lang=ts"
export * from "./order-packed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports